export const CHECKOUT_FEATURE = 'checkout';
export const CHECKOUT_CORE_FEATURE = 'checkoutCore';
